module.exports = __webpack_public_path__ + "img/7.617f6548.webp";